module.exports = __webpack_public_path__ + "media/login.c27d6e42.mp4";